// extracted by mini-css-extract-plugin
export var copyIcon = "_yz-2";
export var discountCard = "_yz-0";
export var discountCode = "_yz-3";
export var discountContent = "_yz-1";
export var loadingCard = "_yz-4";